<div class="avi-page-header__header-container">
    <ng-content></ng-content>
    <h2 class="avi-page-header__header-text">
        {{ headerText }}
    </h2>
    <ng-content select="avi-page-header_edit-button"></ng-content>
    <cds-button
        *ngIf="showEditButton"
        action="flat"
        title="{{ buttonToolTip }}"
        [disabled]="disableClick"
        (click)="onClick()"
        class="avi-page-header__edit-button"
    >
        {{ buttonLabelText }}
    </cds-button>
    <div class="avi-page-header__selectors-container">
        <timeframe-selector
            *ngIf="showTimeframeSelector"
            class="avi-page-header__timeframe-selector"
        ></timeframe-selector>
        <metric-values-selector
            *ngIf="showMetricValuesSelector"
            class="avi-page-header__metric-values-selector"
        ></metric-values-selector>
    </div>
</div>
